<footer class="bg-dark-pjus text-white text-center py-3 ">
  <div class="container">
    <span class="color-white">Parceiro &copy; {{ano | date:'yyyy'}} PJUS</span>
  </div>
</footer>